export default __webpack_public_path__ + "media/images/landlords_page/overlay_slider_2-337182daae1aeab0e6f02dc221c684e7.png";